/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.sign_ups.init());


App.sign_ups = {

  init() {
    if (!$('.js-promo-code-toggle').length) { return; }

    return $(document)
      .off('click', '.js-promo-code-toggle', App.sign_ups.promo_code_toggled)
      .on('click', '.js-promo-code-toggle', App.sign_ups.promo_code_toggled);
  },


  promo_code_toggled(evt) {
    evt.preventDefault();
    $(this)
      .closest('.form-group')
      .find('.fade')
      .addClass('in')
      .find('input')
      .focus();
    return $(this)
      .addClass('fade');
  }
};
